/**
 * QUAL-001 / D143 — « Constatée le » d'une non-conformité NEUVE (modale de création).
 *
 * Pré-rempli et borné au jour de l'ORGANISME (`useJourDeLOrganisme`) : celui
 * dont le serveur se sert pour refuser une date future (`NC_DETECTED_IN_FUTURE`).
 * Le pré-remplissage suivait le jour du NAVIGATEUR (`new Date()`), la borne
 * aussi : un poste en avance sur l'organisme proposait un jour refusé.
 *
 * `null` = pas encore touchée : la date SUIT le jour servi, même arrivé après
 * l'ouverture (moule D43 du Matériel, `useRecordControlForm`).
 */
import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useJourDeLOrganisme } from '@/hooks/useJourDeLOrganisme'

import { phraseDuRefusDuConstatApi } from './constatDeLaNC'

export function useConstatDUneNCNeuve() {
    const { t, i18n } = useTranslation()
    const jour = useJourDeLOrganisme()
    const [dateSaisie, setDateSaisie] = useState<string | null>(null)
    const [refus, setRefus] = useState<string | null>(null)

    /** Une date choisie efface le refus précédent : il portait sur une autre. */
    const choisir = useCallback((iso: string) => {
        setDateSaisie(iso)
        setRefus(null)
    }, [])

    /** À chaque ouverture : le jour servi, aucun refus. */
    const repartir = useCallback(() => {
        setDateSaisie(null)
        setRefus(null)
    }, [])

    /** Vrai si `err` est un refus de la date — il est alors dit sous le champ. */
    const direLeRefus = useCallback(
        (err: unknown): boolean => {
            const phrase = phraseDuRefusDuConstatApi(err, t, i18n.language)
            if (phrase) setRefus(phrase)
            return phrase !== null
        },
        [t, i18n.language],
    )

    return { jour, detectedAt: dateSaisie ?? jour.aujourdhui, refus, choisir, repartir, direLeRefus }
}
